import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { ColdSubject } from 'app/core/guards/cold-subject';
import { CustomerInfoLoadIfNormalUserGuard } from 'app/core/guards/customer-info-load-if-normal-user.guard';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { OrderSandbox } from 'app/core/sandboxes/order.sandbox';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { logger } from 'app/core/util/logger';
import { Observable } from 'rxjs';
import * as fromRoot from '..';

/**
 * Guard to async load a ccr order before following a route
 */
@Injectable({ providedIn: 'root' })
export class GetCCRGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;
  private sandbox: OrderSandbox;

  constructor(@Inject(forwardRef(() => Store)) store, @Inject(forwardRef(() => OrderSandbox)) sandbox) {
    this.store = store;
    this.sandbox = sandbox;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    logger.debug(`In GetCCRGuard`);
    return new ColdSubject(() =>
      this.sandbox.openCcrDetail({
        salesOrderNumber: route.queryParamMap.get('salesOrderNumber'),
        etmOrderNumber: route.paramMap.get('etmOrderNumber'),
        createOrEdit: route.data.createOrEdit || 'create',
        ccrNumber: route.params.ccrNumber
      })
    );
  }

  getDependencies(): any {
    return [CustomerInfoLoadIfNormalUserGuard, AuthorizationGuard];
  }

  getDependencyRouteData(): any {
    return {
      authorization: 'ORDER.UPDATE',
    };
  }
}
